var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFireplace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3392_14309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.63238 10.2815V19.7115C6.63238 19.9876 6.40852 20.2115 6.13237 20.2115H4.48437C4.20823 20.2115 3.98438 19.9876 3.98438 19.7115V5.64746H19.8724V19.7115C19.8724 19.9876 19.6485 20.2115 19.3724 20.2115H17.7244C17.4482 20.2115 17.2244 19.9876 17.2244 19.7115V10.2815C17.2244 9.91604 16.9278 9.61946 16.5624 9.61946H7.29437C6.92895 9.61946 6.63238 9.91604 6.63238 10.2815Z",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 5.64746H21.86",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 3H21.86",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9293 13.1077C13.6948 14.6323 14.5773 16.1171 14.5773 17.5616C14.5773 19.024 13.3916 20.2096 11.9293 20.2096C10.4669 20.2096 9.28125 19.0061 9.28125 17.5616C9.28125 16.1171 10.1637 14.6323 11.9293 13.1077Z",
    stroke: "#2B363D",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3392_14309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireplace);
export default __webpack_public_path__ + "static/media/Fireplace.356bfd424fb987b943f7b9f96f10340b.svg";
export { ForwardRef as ReactComponent };